import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import TeacherCompaniesList from '../../components/views/teacher/CompaniesList'
import TeacherMiniCompanies from '../../components/views/teacher/MiniCompanies'

import injectRole from '../../components/HOC/injectRole'

import { TRoles, TRoutes } from '../../shared/const'
import { isJmcTeacher } from '../../shared/miniCompanies'

function CompaniesList(props) {
	// An einer Volksschule sind die Unternehmen der Lehrkraft ihre Junior Mini
	// Companies — dieselbe Liste, die bis 02.11.2026 einen eigenen Menüpunkt hatte.
	if (isJmcTeacher(props.role, props.profile)) return <TeacherMiniCompanies asCompanies />
	if (props.role === TRoles.TEACHER) return <TeacherCompaniesList />
	else return <Redirect to={TRoutes.DASHBOARD} />
}

CompaniesList.propTypes = {
	role: PropTypes.string.isRequired,
	profile: PropTypes.object
}

export default injectRole(CompaniesList, state => ({ profile: state.user.profile }))
